/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import GradientButton from '../MUICustomButton/GradientButton';
import type { TableColumn } from 'react-data-table-component';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import type {
  JobListPropType,
  JobApiResponse,
  exportJobParam,
  TablePaginationActionsProps,
  JobColumnApiResponse,
  MatchStatisticsResponse,
} from 'src/components/types/types';
import {
  getJobListById,
  getColumnListByJId,
  ExportJobData,
  ExportStandardJobData,
  DownloadSourceCSV,
  MatchStatusReport
} from 'src/services/countandorderServices';
import {
  IconButton,
  Menu,
  Tooltip,
  Box,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store/store';
// import fieldData from './customFielddata';
import TablePagination from '@mui/material/TablePagination';

import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import _debounce from 'lodash/debounce';
import MUIModal from '../MUIModal/MUIModal';
import ConvertToOrder from './ConvertToOrder';
// import ExportStandardData from './ExportStandardData';
import ConvertDataExport from './CustomDataExport';
import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import JobDetails from './JobDetails';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import MatchStatistics from './MatchStatistics';


const JobList: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [columnLoading, setColumnLoading] = useState<boolean>(true);
  const [JobListingData, setJobListData] = useState<JobListPropType[]>([]);
  const [columnListData, setColumnListData] = useState<string[]>([]);
  const [anchorActionEl, setAnchorActionEl] = useState<
    Record<number, HTMLElement | null>
  >({});
  const [customDataOpen, setCustomDataOpen] = useState<Record<number, boolean>>(
    {},
  );

  const [selectedJobId, setSelectedJobId] = useState<number>(0);

  const { user } = useSelector((state: RootState) => state.auth);
  const [jobListValue, setInputValueJoblist] = useState<string>('');
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [perPage, setPerPage] = useState<number>(10);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [sortColumn, setSortColumn] = useState<string>('');
  const [projectTypeId, setProjectTypeId] = useState<number>(10);
  const [sortOrder, setSortOrder] = useState<number>(1);
  const [showCountToOrderModal, setShowCountToOrderModal] = useState<boolean>(false);
  const [showMatchStatisticsModal, setShowMatchStatisticsModal] = useState<boolean>(false);
  const [matchStatisticsData, setMatchStatisticsData] = useState<MatchStatisticsResponse[]>();
  const [showCustomDataModal, setshowCustomDataModal] = useState<boolean>(false)
  // const [showExportStandardDataModal, setShowExportStandardDataModal] = useState<boolean>(false)
  // const [standardJobID, setStandardJobID] = useState<number>(0);
  // const [standardProjectTypeID, setStandardProjectTypeID] = useState<number>(0);
  const [showJobDetailDataModal, setShowJobDetailDataModal] = useState<boolean>(false);
  const [jobDetails, setJobDetails] = useState<JobListPropType>();
  // const [requestId, setRequestId] = useState<string>('');
  const [jiraID, setJiraID] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>(''); 
  const handleNewRequestClick = (): void => {
    navigate('/manage-jobs/new-request');
  };
  const reloadTime = process.env.REACT_APP_JOBLIST_RELOAD_TIME as unknown as number ?? 0;
  useEffect(() => {
    getJobListData();
    if (reloadTime !== null && reloadTime !== 0) {
      const interval = setInterval(() => {
        setLoading(true)
        getJobListData();
      }, reloadTime);

      // Clear the interval on component unmount
      return () => clearInterval(interval);

    }
  }, [pageNumber, perPage, sortColumn, jobListValue, sortOrder]);


  const getJobListData = (jobListSearch = ''): void => {
    const userId = user?.id;
    const data = {
      userId: userId,
      searchValue: jobListSearch !== '' ? jobListSearch : jobListValue,
      pageNumber: pageNumber + 1,
      pageSize: perPage,
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      sortColumn: sortColumn || '',
      sortOrder: sortOrder
    };

    getJobListById(JSON.stringify(data))
      .then((res: JobApiResponse) => {
        if (res.status === 200) {
          setLoading(false)
          setJobListData(res.data.data.jobMasterDataList);
          setTotalRecords(res.data.data.totalRecords);
        }
      })
      .catch((error) => console.log('Error: ', error))
      .finally(() => setLoading(false));
  };

  const debounceFn = useCallback(_debounce(getJobListData, 1000), []);
  const handleActionClick = (
    event: React.MouseEvent<HTMLElement>,
    jobID: number,
    projectTypeID: number,
    jiraID: string
  ): void => {
    setProjectTypeId(projectTypeID);
    setAnchorActionEl({ ...anchorActionEl, [jobID]: event.currentTarget });
    setJiraID(jiraID);
  };
  const handleActionClose = (
    jobID: number,
    action: string | null = null,
    tableName = ''
  ): void => {
    setSelectedJobId(jobID);


    if (action === 'Custom') {
      setshowCustomDataModal(true);
      setColumnLoading(true);

      getColumnListByJId(jobID)
        .then((res: JobColumnApiResponse) => {
          if(res.data.result === 1) {
            setColumnListData(res.data.data);
          }
        })
        .catch((error) => console.log('Error fetching column data:', error))
        .finally(() => {
          setColumnLoading(false);
        });
    } else {
      setAnchorActionEl({ ...anchorActionEl, [jobID]: null });

      if (action === 'Standard') {
        setLoading(true);
        const data: exportJobParam = {
          jobid: jobID,
          projectTypeID: projectTypeId
        };
        const fileName = jobID + '_' + action + '.xlsx';
        exportData(data, fileName, 'Standard');
      }
      if (action === 'DownloadSourceCSV') {
        setLoading(true);
        const fileName = `${tableName}.csv`;

        // Call the DownloadSourceCSV function here
        DownloadSourceCSV(jobID)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Set the filename
            document.body.appendChild(link);
            link.click(); // Simulate click to trigger download
            link.parentNode?.removeChild(link); // Cleanup
          })
          .catch((error) => console.log('Error downloading CSV:', error))
          .finally(() => setLoading(false));
      }
    }
  };
  // const exportData = (data :exportJobParam ):void =>{

  //   ExportJobData(data).then((res: JobApiResponse) => {
  //     if (res.status === 200) {
  //       setLoading(false);
  //     }
  //   })
  //   .catch((error) => console.log('Error: ', error))
  //   .finally(() => {
  //     setLoading(false);
  //   });
  //   }
  const exportData = (data: exportJobParam, fileName: string, action: string): void => {
    if (action === "Standard") {
      ExportStandardJobData(data.jobid)
        .then((res) => {
          if (res.status === 200) {
            // Create a Blob from the response data
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            const contentType = res.headers['content-type'] || "application/octet-stream";
            const blob = new Blob([res.data], { type: contentType });

            // Check if blob size is 0 or exactly 92 bytes - File not found in blob storage.
            if (blob.size === 92|| blob.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
              NotificationManager.error("File not found in blob storage.");
              setLoading(false);
              return;
            }
            else{
            // Create a Blob from the response data
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const blob = new Blob([res.data], { type: res.headers['content-type'] });

            // Create a link element to download the file
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);


            window.URL.revokeObjectURL(url);

            setLoading(false);
            setAnchorActionEl({ ...anchorActionEl, [selectedJobId]: null });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            NotificationManager.success("Report downloaded successfully")
          } }else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            NotificationManager.error("Failed to download file")
            console.error('Failed to download file');
            setLoading(false);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
          NotificationManager.error("Failed to download file")
          console.log('Error: ', error);
          setLoading(false);
        });
    } else {


      ExportJobData(data)
        .then((res) => {
          if (res.status === 200) {
            // Create a Blob from the response data
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const blob = new Blob([res.data], { type: res.headers['content-type'] });

            // Create a link element to download the file
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);


            window.URL.revokeObjectURL(url);

            setLoading(false);
            setAnchorActionEl({ ...anchorActionEl, [selectedJobId]: null });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            NotificationManager.success("Report downloaded successfully")
          } else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            NotificationManager.error("Failed to download file")
            console.error('Failed to download file');
            setLoading(false);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
          NotificationManager.error("Failed to download file")
          console.log('Error: ', error);
          setLoading(false);
        });
    }


  };



  const handleDownload = (selectedCustomFields: string[]): void => {
    const JobId = selectedJobId;
    setshowCustomDataModal(false)
    setLoading(true);
    console.log(selectedCustomFields);
    const data: exportJobParam = {
      "jobid": JobId,
      "columns": selectedCustomFields,
      "exporttype": "Custom",
    };
    const fileName = JobId + '_Custom.xlsx';

    exportData(data, fileName, "Custom");

    setCustomDataOpen({ ...customDataOpen, [JobId]: false });
    setAnchorActionEl({ ...anchorActionEl, [JobId]: null });
  };


  const isTextTruncated = (element: HTMLElement | null): boolean => {
    if (!element) return false;
    return element.scrollWidth > element.clientWidth;
  };
  const handleJobInfo = (jobDet: JobListPropType): void => {
    setShowJobDetailDataModal(true);
    setJobDetails(jobDet);
    console.log(jobDet);
  }
  const handleJobDetailDataModal = (): void => {
    setShowJobDetailDataModal(false);
  }
  const handleMatchStatistics = (jobID: number): void => {
    console.log(`Match Statistics for job ${jobID}`);
    
    MatchStatusReport(jobID)
        .then((res: JobColumnApiResponse) => {
          console.log(res);
          console.log(res.data.result);
          if(res.data.result === 1) {
            console.log(2121212);
            setMatchStatisticsData(res.data.data);
            setShowMatchStatisticsModal(true);
          }
        })
        .catch((error) => console.log('Error fetching column data:', error))
        .finally(() => {
          setColumnLoading(false);
        });
  };
  const handleCloseMatchStatistics = (): void => {
    setShowMatchStatisticsModal(false);
  }
  const renderWithTooltip = (text: string): JSX.Element => {
    const textRef = useRef<HTMLDivElement>(null);

    return (
      <Tooltip
        title={text}
        placement="top"
        disableHoverListener={!isTextTruncated(textRef.current)}
      >
        <div
          ref={textRef}
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {text}
        </div>
      </Tooltip>
    );
  };

  const handleCloseConvertToOrderModal = (): void => {
    setShowCountToOrderModal(false);
    setErrorMessage('');
  }

  // const handleCloseExportStandardDataModal = (): void => {
  //   setShowExportStandardDataModal(false)
  // }

  const handleRefreshData = (): void => {
    setShowCountToOrderModal(false)
    getJobListData();
  }
  const handleCustomDataModal = (): void => {
    setAnchorActionEl({ ...anchorActionEl, [selectedJobId]: null });
    setshowCustomDataModal(false)
  }

  const handleJobEdit = (jobId: string): void => {
    navigate(`/manage-jobs/edit-request/${jobId}`)
  }

  const columns: TableColumn<JobListPropType>[] = [
    {
      name: 'Job ID',
      selector: (row: JobListPropType) => row.jobID,
      width: '7%',//width
      sortable: true,
      sortField: 'jobID'
    },
    {
      name: 'Jira ID',
      selector: (row: JobListPropType) => row.jiraID,
      width: '10%',
      sortable: true,
      sortField: 'jiraID',
      // cell: (row) => renderWithTooltip(row.requestID),
      cell: (row) => {
        return (
            <div className='flex w-full'>
                {row.jiraID}
            </div>
        )
      }
    },

    {
      name: 'Request Name',
      selector: (row: JobListPropType) => row.requestName,
      width: '14%',
      sortable: true,
      sortField: 'requestName',
      // cell: (row) => renderWithTooltip(row.requestName),
      cell: (row) => {
        return (
            <div className='flex w-full'>
                {row.requestName}
            </div>
        )
      }
    },
    {
      name: 'Project',
      selector: (row: JobListPropType) => row.projectTypeName,
      width: '10%',
      sortable: true,
      sortField: 'projectTypeName',
      cell: (row) => renderWithTooltip(row.projectTypeName),
    },
    {
      name: 'Job Type',
      selector: (row: JobListPropType) => row.jobTypeName,
      width: '10%',
      sortable: true,
      sortField: 'jobTypeName',
      // cell: (row) => renderWithTooltip(row.jobTypeName),
      cell: (row) => {
        return (
            <div className='flex w-full'>
                {row.jobTypeName}
            </div>
        )
      }
    },
    {
      name: 'Client Name',
      selector: (row: JobListPropType) => row.clientName,
      width: '16%',
      sortable: true,
      sortField: 'clientName',
      // cell: (row) => renderWithTooltip(row.clientName),
      cell: (row) => {
        return (
            <div className='flex w-full'>
                {row.clientName}
            </div>
        )
      }
    },
    {
      name: 'Status',
      selector: (row: JobListPropType) => row.jobStatusName,
      width: '10%',
      sortable: true,
      sortField: 'jobStatusName',
      cell: (row) => {
        const getStatusStyles = (status: string): { background: string; color: string; fontSize: string } => {
          switch (status) {
            case 'P':
              return {
                background: '#FFF2C2',
                color: '#FF7A00',
                fontSize: '12px'
              };
            case 'S':
              return {
                background: '#CCFFEA',
                color: '#06A864',
                fontSize: '12px'
              };
            case 'F':
              return {
                background: '#FDE0E0',
                color: '#DC3545',
                fontSize: '12px'
              };
            case 'Q':
              return {
                background: '#D9DBF9',
                color: '#191975',
                fontSize: '12px'
              };
            default:
              return {
                background: '#F8F9FA',
                color: '#6C757D',
                fontSize: '12px'
              };
          }
        };

        const { background, color } = getStatusStyles(row.jobStatus);

        return (
          <div className='flex whitespace-nowrap text-12 justify-center px-[15px] py-[3px] rounded-full w-full'
            style={{
              background,
              color,

            }}
          >
            {row.jobStatusName}
          </div>
        );
      }
    },
    {
      name: 'Request Date',
      selector: (row) => row.requestDate,
      sortable: true,
      width: '10%',
      sortFunction: (rowA, rowB) => {
        const dateA = moment(rowA.requestDate);
        const dateB = moment(rowB.requestDate);
        return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
      },
      format: (row) => moment(row.requestDate).format('MM/DD/YYYY'),
    },

    // {
    //   name: 'Status',
    //   selector: (row: JobListPropType) => row.jobStatusName,
    //   width: '150px',
    //   sortable: true,
    //   sortField: 'jobStatusName',
    //   cell: (row) => renderWithTooltip(row.jobStatusName),
    // },
    {
      name: 'Actions',
      cell: (row: JobListPropType) => {
        const projectType = row.projectTypeName.toLowerCase();

        const [anchorElImage, setAnchorElImage] = useState<Record<number, HTMLElement | null>>({});

        const handleImageMenuClick = (event: React.MouseEvent<HTMLElement>, jobID: number): void => {
          setAnchorElImage({ ...anchorElImage, [jobID]: event.currentTarget });
        };

        const handleImageMenuClose = (jobID: number): void => {
          setAnchorElImage({ ...anchorElImage, [jobID]: null });
        };

        const handleConvertToOrder = (jobID: number, jiraID: string): void => {
          console.log(`Convert to order for job ${jobID}`);
          handleImageMenuClose(jobID);
          setSelectedJobId(jobID);
          // setRequestId(requestID);
          setJiraID(jiraID)
          setShowCountToOrderModal(true)
        };
      

        // const handleExportStandardData = (jobID: number, projectTypeID: number): void => {
        //   console.log(`ExportStandardData for job ${projectTypeID}`);
        //   setAnchorActionEl({ ...anchorActionEl, [jobID]: null });
        //   setStandardJobID(jobID)
        //   setStandardProjectTypeID(projectTypeID)
        //   handleImageMenuClose(jobID);
        //   setShowExportStandardDataModal(true)
        // };


        // const handleRefresh = (jobID: number): void => {
        //   console.log(`Refresh job ${jobID}`);
        //   handleImageMenuClose(jobID);
        // };
        return (
          <div className="flex items-center" key={row.jobID}>
            <button className="btn btn-circle btn-outline border-0 icon-hover-container" onClick={() => handleJobEdit(row.jobRequestId)} disabled={row.jobStatus !== 'S' && row.jobStatus !== 'F'}>
              <img src={'/assets/images/icons/EditIcon.svg'} alt="" />
            </button>
            <div className="flex">
              
              <IconButton
                aria-label="more"
                id="long-button"
                aria-haspopup="true"
                onClick={(e) =>
                  handleActionClick(
                    e as React.MouseEvent<HTMLElement>,
                    row.jobID,
                    row.projectTypeID,
                    row.jiraID
                  )
                }
                disabled={row.jobStatus !== 'S'}
                sx={{
                  padding: '4px'
                }}
              >
                {row.jobStatus !== 'S' ?
                  <IosShareRoundedIcon sx={{ color: '#c8ced8' }} /> :
                  <IosShareRoundedIcon sx={{ color: '#77869E' }} />
                }


              </IconButton>
              <Menu
                className="table-action-menu"
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorActionEl[row.jobID]}
                open={Boolean(anchorActionEl[row.jobID])}
                onClose={() => handleActionClose(row.jobID)}
                PaperProps={{
                  style: {
                    maxHeight: '350px',
                    width: customDataOpen[row.jobID] ? '20ch' : '15ch',
                    overflowY: 'auto',
                    position: 'relative',
                  },
                }}
                sx={{
                  '& .MuiPaper-root': {
                    border: '1px solid gray',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    fontFamily: 'Manrope, sans-serif',
                  },
                  '& .MuiMenuItem-root': {
                    borderBottom: '1px solid #e0e0e0',
                    fontSize: '14px', // Font size remains the same
                    padding: '8px 12px', // Reduced padding for smaller clickable area
                    minHeight: '32px', // Reduced minimum height of the menu item
                    fontFamily: 'Manrope, sans-serif',
                    '&:last-child': {
                      borderBottom: 'none',
                    },
                  },
                }}
              >

                <>
                  <MenuItem
                    onClick={() => handleActionClose(row.jobID, 'Standard')}
                  >
                    <span className='text-muted font-normal'>Standard data</span>
                  </MenuItem>
                  {/* HL-2125 Modify the job listing page to hide the custom export option when the ProjectType is set to 'Count'- UI */}
                  {projectType !== 'count' && (
                    <MenuItem onClick={() => handleActionClose(row.jobID, 'Custom')}>
                      <span className='text-muted font-normal'>Custom data</span>
                    </MenuItem>
                  )}

                </>

              </Menu>
            </div>
            <div className='flex'>
              <IconButton
                aria-label="edit"
                onClick={() => handleJobInfo(row)}
                sx={{
                  padding: '4px'
                }}
              >
                <InfoOutlinedIcon sx={{ color: '#77869E' }} />
              </IconButton></div>
            <div className="flex">
              <IconButton
                aria-label="edit"
                onClick={(e) => handleImageMenuClick(e, row.jobID)}
                sx={{
                  padding: '4px'
                }}
              >
                <MoreVertIcon sx={{ color: '#77869E' }} />
              </IconButton>

              <Menu
                id={`image-menu-${row.jobID}`}
                className="table-action-menu"
                anchorEl={anchorElImage[row.jobID]}
                open={Boolean(anchorElImage[row.jobID])}
                onClose={() => handleImageMenuClose(row.jobID)}
                PaperProps={{
                  style: {
                    maxHeight: '350px',
                    width: customDataOpen[row.jobID] ? '30ch' : '20ch',
                    overflowY: 'auto',
                    position: 'relative',
                  },
                }}
                sx={{
                  '& .MuiPaper-root': {
                    border: '1px solid gray',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    fontFamily: 'Manrope, sans-serif',
                  },
                  '& .MuiMenuItem-root': {
                    borderBottom: '1px solid #e0e0e0',
                    fontSize: '14px',
                    padding: '8px 12px',
                    minHeight: '32px',
                    fontFamily: 'Manrope, sans-serif',
                    '&:last-child': {
                      borderBottom: 'none',
                    },
                  },
                }}
              >
                <MenuItem onClick={() => handleActionClose(row.jobID, 'DownloadSourceCSV', row.tableName)}>
                  <span className='text-muted font-normal'>Download source CSV</span>
                </MenuItem>
                {/* Conditionally render the options based on Project Type */}
                {(projectType === 'count' && row.jobStatus === 'S') && (
                  <MenuItem onClick={() => handleConvertToOrder(row.jobID, row.jiraID)}>
                    <span className='text-muted font-normal'>Convert to order</span>
                  </MenuItem>
                )}
                {(row.jobStatus === 'S') && (
                  <MenuItem onClick={() => handleMatchStatistics(row.jobID)}>
                    <span className='text-muted font-normal'>Match statistics</span>
                  </MenuItem>
                )}
                {/* {projectType === 'order' && (
                  <MenuItem onClick={() => handleRefresh(row.jobID)}>
                    Refresh
                  </MenuItem>
                )} */}
              </Menu>
            </div>


          </div>
        );
      },
      width: '10%',
    },
  ];
  const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number): void => {
    setPageNumber(newPage)

  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handlePerRowsChange = (event: { target: { value: string } }) => {
    setPerPage(parseInt(event.target.value, 10));
    setPageNumber(0);
  };
  const TablePaginationActions = (props: TablePaginationActionsProps): JSX.Element => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (
      event: React.MouseEvent<HTMLButtonElement>,
    ): void => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  }

  const handleSort = (column: TableColumn<JobListPropType>, sortDirection: 'asc' | 'desc'): void => {
    const sortColumn = column.sortField;
    const sortOrder = sortDirection === 'asc' ? 1 : 0;
    setSortColumn(sortColumn as string);
    setSortOrder(sortOrder);
    getJobListData('');
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setInputValueJoblist(e.target.value);
    setPageNumber(0);
    debounceFn(e.target.value);
  };
console.log(matchStatisticsData);
  return (
    <React.Fragment>
      <h2 className="text-2xl font-semibold text-title">Counts and Orders</h2>
      <div className="flex my-5 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="form-control">
            <input
              type="text"
              placeholder="Search with Jira ID"
              className="input input-bordered w-auto search-input-white focus:ring-0 focus:outline-none focus:border-primary font-normal text-14 text-muted"
              value={jobListValue}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">
          <GradientButton color="red" onClick={handleNewRequestClick}>
            <span
              style={{
                width: '20px',
                height: '20px',
                background: '#fff',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '50px',
                marginRight: '5px',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
              >
                <path
                  d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z"
                  fill="#F13139"
                />
                <path
                  d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z"
                  fill="#F13139"
                />
              </svg>
            </span>
            New Request
          </GradientButton>
        </div>
      </div>
      <div
        // className=" overflow-y: scroll;"
        // style={{ minWidth: '500px', tableLayout: 'fixed', width: '100%', maxHeight: "calc(100vh - 250px)", overflowY: "auto", overflowX: "hidden" }}
      >

        <CustomDataTable
          columns={columns}
          data={JobListingData !== null ? JobListingData : []}
          pagination
          responsive
          paginationServer
          onSort={handleSort}
          sortServer
          paginationComponent={() =>
            <TablePagination
              component="nav"
              rowsPerPageOptions={[10, 15, 20, 25, 30]}
              count={totalRecords}
              page={pageNumber}
              onPageChange={handlePageChange}
              rowsPerPage={perPage}
              onRowsPerPageChange={handlePerRowsChange}
              ActionsComponent={TablePaginationActions}
            />
          }

          progressPending={loading}
        />

      </div>




      <MUIModal title='Convert to order' openModal={showCountToOrderModal} closeModal={handleCloseConvertToOrderModal} >
      {errorMessage !== "" && (
                <div style={{ color: 'red', textAlign: 'left', marginLeft:'1rem',marginBottom: '1rem' }}>
                    {errorMessage}
                </div>
            )}
        <ConvertToOrder closeModal={handleCloseConvertToOrderModal} selectedJobId={selectedJobId} jiraID={jiraID} refreshData={handleRefreshData} setConvertErrorMessage={setErrorMessage} />

      </MUIModal>
      <MUIModal title='Export custom data' openModal={showCustomDataModal} closeModal={handleCustomDataModal} width={'50%'} >
        <ConvertDataExport
          closeModal={handleCustomDataModal}
          columnListData={columnListData}
          columnLoading={columnLoading}
          handleDownload={handleDownload}
          jiraID={jiraID ?? ''}
        />
      </MUIModal>
      {/* <MUIModal title='Export standard data' openModal={showExportStandardDataModal} closeModal={handleCloseExportStandardDataModal} width={'25%'} >
        <ExportStandardData closeModal={handleCloseExportStandardDataModal} standardJobID = {standardJobID} standardProjectTypeID = {standardProjectTypeID} />
      </MUIModal> */}


      <MUIModal
        title={`Request Details`}
        openModal={showJobDetailDataModal}
        closeModal={handleJobDetailDataModal}
        width={'50%'}
      >
        <JobDetails jobDetails={jobDetails as JobListPropType} />
      </MUIModal>
      <MUIModal
        title={`Match Statistics`}
        openModal={showMatchStatisticsModal}
        closeModal={handleCloseMatchStatistics}
        width={'50%'}
      >
        <MatchStatistics MatchStatisticsData={matchStatisticsData as MatchStatisticsResponse[]} />
      </MUIModal>
    </React.Fragment>
  );
};

export default JobList;
